import React from "react";
import { Helmet } from "react-helmet";

import { MainStyled } from "../layout/Main";
import Intro from "./Intro";
import ProductList from "./ProductList";

function Products() {
  return (
    <>
      <Helmet>
        <title>DamecaLV - Produsele noastre</title>
        <meta
          name="DamecaLV"
          content="Gama de produse pe care le avem acum la dispozitie. Calitate si siguranta sunt unele dintre principiile noastre de baza in afaceri si viata."
        />
      </Helmet>
      <MainStyled>
        <Intro />
        <ProductList />
      </MainStyled>
    </>
  );
}

export default Products;
